export default {
  PreChecker: 'Υπάλληλος Προελέγχου',
  SpecialProponent: 'Χειριστής',
  ExecutiveBoardMember: 'Μέλος Επιτροπής',
  President: 'Πρόεδρος',
  VicePresidentA: 'Αντιπρόεδρος Α',
  VicePresidentB: 'Αντιπρόεδρος Β',
  ProcessViewer: 'Διοικητικός Έλεγχος',
  AcademicDirector: 'Διευθυντής Αναγνώρισης',
  Admin: 'Διαχειριστής',
  RegistryAdmin: 'Διαχειριστής Μητρώων',
  PhdRegistry: 'Σύνδεσμος ΕΑΔΔ',
  CouncilMember: 'Μέλος ΔΣ',
  DocutracksUser: 'Χρήστης ΣΗΔΕ (Docutracks)',
  TemporaryUser: 'Προσωρινός χρήστης',
  PrintDecision: 'Καταχωρητής Απόφασης',
  AcademicConsultant: 'Αξιολογητής',
  Auditor: 'Υπάλληλος Αρχής Διαφάνειας',
  bachelor: 'Τίτλος 1ου κύκλου σπουδών',
  master: 'Τίτλος 2ου κύκλου σπουδών',
  phd: 'Τίτλος 3ου κύκλου σπουδών',
  userW_: 'Εξωτερικός Χρήστης',
  precheckerW_: 'Εξωτερικούς Χρήστες',
  precheckerCompensatoryW_: 'Εξετάσεις σε Πανεπιστημιακό Ίδρυμα',
  proponentW_President: 'Πρόεδρο',
  proponentW_Prechecker: 'Προέλεγχο',
  proponentW_Board: 'Εκτελεστική επιτροπή',
  proponentW_Admin: 'Διαχειριστή',
  proponentW_ReappraisalBoard: 'Ειδ. Επιτρ. Επανεξέτασης',
  viewerW_Proponent: 'Χειριστή',
  viewerW_Vice: 'Αντιπρόεδρο',
  viewerW_Board: 'Εκτελεστική επιτροπή',
  viceW_President: 'Πρόεδρο',
  boardW_President: 'Πρόεδρο',
  boardW_Proponent: 'Εισηγητή',
  boardW_Consultant: 'Ακαδημαϊκό',
  presidentW_Prechecker: 'Προέλεγχο',
  presidentW_Consultant: 'Αξιολογητή',
  printDecisionW_: 'Καταχωρητής Απόφασης',
  precheckersQueue: 'Ουρά προελέγχου',
  presidentW_PrintDecision: 'Καταχωρητή',
  president_finalized: 'Ολοκληρωμένη-Παραλαβή',
  consultantw_proponent: 'Χειριστή',
  consultantw_President: 'Πρόεδρο',
  presidentW_Viewer: 'Διοικητικό έλεγχο',
  presidentW_AcademicDirector: 'Δ/ντή Ακαδ. Αναγνώρισης (Αξιολ.)',
  presidentW_AcademicDirector_Reappraisal: 'Δ/ντή Ακαδ. Αναγνώρισης (Επανεξ.)',
  presidentW_ReappraisalBoard: 'Ειδ. Επιτρ. Επανεξέτασης (επιστροφή)',
  boardW_: 'Εκτελεστική επιτροπή',
  REDIRECTION_NEEDED: 'Επαναδρομολόγηση',
  printDecisionW_President: 'Ουρά καταχωρητών',
  printdecisionw_: 'Πρόεδρο',
  personalQueue: 'Αναμονή',
  auditorW_: 'Διαχειριστή για Έλεγχο',
  viceW_Prechecker: 'Προέλεγχο',
  viceW_Board: 'Επιτροπή',
  viceW_ReappraisalBoard: 'Ειδ. Επιτρ. Επανεξέτασης',
  reappraisalBoardW_Vice: 'Αντιπρόεδρο',
  reappraisalBoardW_President: 'Πρόεδρο',
  viewerW_President: 'Πρόεδρο',
  academicDirectorW_Proponent: 'Χειριστή (Επανεξ.)',
  academicDirectorW_President: 'Πρόεδρο',
  academicDirectorW_ReappraisalBoard: 'Ειδ. Επιτρ. Επανεξέτασης'
}



// WEBPACK FOOTER //
// ./src/store/dictionaryForMenu.js